<template>
  <Base
    icon="mdi-school"
    :satisfied="requirement.satisfied"
    tooltip
  >
    <span>
      {{ requirement.qualificationCategory.name }}
    </span>
    <span slot="tooltip">
      {{ first ? 'The ideal candidate' : 'and' }}
      {{ requirement.mandatory ? 'must' : 'could' }}
      {{ requirement.negative ? 'not' : '' }} have a
      {{ requirement.qualificationCategory.name }}
    </span>
  </Base>
</template>

<script>
// Component
import Base from '@/components/guest/opportunities/requirements/Base'

// Vue Component
export default {
  components: { Base },
  props: {
    requirement: { type: Object, required: true },
    first: { type: Boolean },
  },
}
</script>
